import React, { useState, useRef, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CustomRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import "./otp.scss";

import { changePassword } from "../../api/auth";
import AUTH_API from "api/authApi";
import { usePost } from "@hooks/useAuthApi";
import { showNotification } from "utils/helpers";
import Loader from "@common-components/loader/Loader";

export default function OTP() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const formData = useRef({ OTP: "" });
  const email = location.state?.email;
  const [isCodeResend, setIsCodeResend] = useState(false);

  const { mutate: verifyOTP } = usePost("VerifyOTP", AUTH_API.VERIFYOTP);
  const getPasswordEditorOptions = (placeholder) => ({
    stylingMode: "outlined",
    placeholder: "Enter your reset code",
  });

  const { mutate: forgotPassword } = usePost(
    "forgotPassword",
    AUTH_API.FORGOT_PASSWORD
  );

  const passwordEditorOptions = getPasswordEditorOptions("");

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { OTP } = formData.current;
      setLoading(true);

      // const result = await changePassword(password, recoveryCode);
      verifyOTP(
        { email, otp: formData.current.OTP },
        {
          onSuccess: (response) => {
            if (response.isSuccess) {
              navigate("/change-password/:recoveryCode", {
                state: { email, token: response.data.accessToken },
              });
              showNotification("OTP verified", "success");
            } else {
              showNotification("Invalid OTP", "error");
            }
          },
          onError: (error) => {
            showNotification("Invalid OTP", "warning");
          },
          onSettled: () => {
            setLoading(false);
          },
        }
      );
      // setLoading(false);

      // if (result.isOk) {
      //   navigate("/change-password/:recoveryCode");
      // } else {
      //   notify(result.message, "error", 2000);
      // }
    },
    [navigate]
  );

  return (
    <>
      <form onSubmit={onSubmit}>
        {/* <p className="text-xl">Enter OTP</p> */}
        {/* <p className="text-xs">Secure Your Account</p> */}
        <Form
          formData={formData.current}
          disabled={loading}
          labelMode="outside"
          labelLocation="top"
          showColonAfterLabel={false}
        >
          <Item
            dataField={"OTP"}
            editorType={"dxTextBox"}
            label={{ visible: false }}
            cssClass="pb-0"
            editorOptions={passwordEditorOptions}
            isRequired={true}
          >
            <RequiredRule message="Otp is required" />
          </Item>
          <Item
            cssClass="p-0"
            render={() => (
              <div className="text-xs text-left pt-[2px]">
                Didn't receive a code?{" "}
                <span
                  className={`  ${isCodeResend ? "text-gray-600 font-semibold" : "text-blue-600 font-semibold hover:underline cursor-pointer"}`}
                  onClick={() => {
                    if (!isCodeResend) {
                      forgotPassword(
                        { email: email },
                        {
                          onSuccess: (response) => {
                            if (response.isSuccess) {
                              showNotification("OTP resent", "success");
                              setIsCodeResend(true);
                            } else {
                              showNotification(
                                response.errors[0].errorMessageEn,
                                "error"
                              );
                            }
                          },
                          onError: (error) => {
                            showNotification(error.message, "warning");
                          },
                        }
                      );
                    }
                  }}
                >
                  Resend
                </span>
              </div>
            )}
          ></Item>

          <ButtonItem>
            <ButtonOptions
              width={"100%"}
              height={"40px"}
              type={"default"}
              useSubmitBehavior={true}
            >
              <span className="dx-button-text">
                {loading ? (
                  <Loader
                  
                  />
                ) : (
                  "Submit"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
      <div className="flex items-center justify-between mt-[70px]">
        <p className="m-0 text-xs">
          B’Logic<sup className="ms-[0.5px]">®</sup> 𝑖QMS
        </p>
        <p className="m-0 text-xs">All rights reserved - 2025</p>
      </div>
    </>
  );
}
